<template>
  <div class="table-action-wrapper">
    <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        }
      }
    }
  },
  created() {
    this.query = Object.assign(this.query, this.config?.query)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    statusOptions() {
      if (!this.extraAttributes.status) {
        return []
      }
      return Object.values(this.extraAttributes.status || [])
    }
  },
  methods: {
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>
